<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <form @submit.prevent="submit">
          <l-alert type="danger" v-show="errorMessage">
            <span>{{ errorMessage }}</span>
          </l-alert>
          <fg-input label="Neues Passwort" type="password" v-model="password" />
          <fg-input label="Neues Passwort bestätigen" type="password" v-model="password_confirmation" />
          <button type="submit" class="btn btn-fill btn-info">Passwort ändern</button>
        </form>
      </card>
    </div>
    <div class="col-sm-6">
      <card class="stacked-form">
        <form @submit.prevent="submitUpdate">
          <div>
            <label>Standardlager</label>
            <div class="form-group has-label" v-if="warehouses.length > 1">
              <multiselect v-model="user.warehouse" :options="warehouses" track-by="id" label="short_name"
                placeholder="Lager auswählen" />
            </div>
          </div>
          <div>
            <label>Signatur</label>
            <div class="form-group has-label">
              <textarea class="form-control" v-model="signature" rows="2"></textarea>
            </div>
          </div>

          <div class="form-group">
            <fg-input>
              <l-checkbox  v-model="use_sig_to_all">
              Signatur bei allen von mir durchgeführten Bestellungen
                einfügen</l-checkbox>
            </fg-input>
          </div>
          <div class="form-group">
            <fg-input>
              <l-checkbox v-model="enable_sound">Scan-Töne einschalten</l-checkbox>
            </fg-input>
          </div>
          <button type="submit" class="btn btn-fill btn-info">Speichern</button>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
import LAlert from 'src/components/Alert'

export default {
  components: {
    LAlert
  },
  data() {
    return {
      password: '',
      password_confirmation: '',
      errorMessage: '',
      warehouses: [],
      user: {},
      signature: '',
      use_sig_to_all: '',
      enable_sound: false
    }
  },
  methods: {
    async submit() {
      await this.initCsrf()

      this.errorMessage = ''
      this.$http.put('user_settings', {
        password: this.password,
        password_confirmation: this.password_confirmation
      }).then(() => {
        this.$notify({
          message: 'Passwort erfolgreich geändert.',
          type: 'success'
        })
        this.$router.push('/')
      }).catch(({ response }) => {
        const key = Object.keys(response.data.errors)[0]
        this.errorMessage = response.data.errors[key][0]
      })
    },
    async submitUpdate() {
      this.$http.put(`/users/warehouse`, { warehouse_id: this.user.warehouse ? this.user.warehouse.id : null }).then(({ data }) => {
        this.$notify({
          message: 'Daten erfolgreich geändert.',
          type: 'success'
        })
        this.$store.commit('authUser', data)
        this.$router.push('/')
      }).catch(({ response }) => {
        this.valErrors = response.data.errors
      })
      if ((this.signature !== this.user.signature || this.use_sig_to_all !== this.user.use_sig_to_all || this.user.enable_sound !== this.enable_sound)) {
        this.$http.put('/users/signature/' + this.user.id, {
          signature: this.signature,
          use_sig_to_all: this.use_sig_to_all,
          enable_sound: this.enable_sound
        })

      }
    }
  },
  created() {
    this.$http.get(`/warehouses`).then(({ data }) => { this.warehouses = data })
    this.$http.get(`/users/${this.$store.state.authUser.id}`).then(({ data }) => {
      this.user = data
      this.signature = this.user.signature
      this.use_sig_to_all = this.user.use_sig_to_all ? true : false
      this.enable_sound = this.user.enable_sound ? true : false
    })
  }
}
</script>

<style></style>
